// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1jkkH","addWidgetButton":"Header_addWidgetButton__2J0iz","dashboardTabs":"Header_dashboardTabs__1Bk70","active":"Header_active__3Osz7"};